import React from 'react';
import BillingByYearTable from './BillingByYearTable';
import Panel from './Panel';

// Every column, every cell a drill-down. The rows are byYear()'s; the columns
// and the WIP rule live in BillingByYearTable / utils/rollup.js.
export default function SummaryByYearTable({ rows, onCellClick }) {
  return (
    <Panel title="Summary by Year" empty={!rows?.length} emptyText="No financial activity yet.">
      <BillingByYearTable rows={rows} onCellClick={onCellClick} />
      <div style={{ fontSize: 12, color: '#6b7280', marginTop: 8 }}>
        WIP left = time value − fees billed − write-offs. A discount clears WIP and shows in its
        own column. Drafts are not counted until issued. “—” marks a year before time was
        recorded in ClientZone.
      </div>
    </Panel>
  );
}
